/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  JoinTradingCompetitionRequest,
  TradingCompetitionLeaderboardResponse,
  TradingCompetitionResponse,
} from '../models/index';

export interface GetCompetitionsRequest {
    status?: GetCompetitionsStatusEnum;
    isReadyToDisplay?: boolean;
    userAddress?: string;
}

export interface GetLeaderboardRequest {
    id: number;
    page?: number;
    limit?: number;
    orderBy?: string;
    orderDirection?: string;
}

export interface JoinCompetitionRequest {
    joinTradingCompetitionRequest: JoinTradingCompetitionRequest;
}

/**
 * 
 */
export class TradingCompetitionApi extends runtime.BaseAPI {

    /**
     * Get list of trading competitions filtered by status
     * Get trading competitions
     */
    async getCompetitionsRaw(requestParameters: GetCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TradingCompetitionResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['isReadyToDisplay'] != null) {
            queryParameters['isReadyToDisplay'] = requestParameters['isReadyToDisplay'];
        }

        if (requestParameters['userAddress'] != null) {
            queryParameters['userAddress'] = requestParameters['userAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/trading-competition`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get list of trading competitions filtered by status
     * Get trading competitions
     */
    async getCompetitions(requestParameters: GetCompetitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TradingCompetitionResponse>> {
        const response = await this.getCompetitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get leaderboard for a specific competition with pagination and sorting
     * Get competition leaderboard
     */
    async getLeaderboardRaw(requestParameters: GetLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TradingCompetitionLeaderboardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaderboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/trading-competition/{id}/leaderboard`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get leaderboard for a specific competition with pagination and sorting
     * Get competition leaderboard
     */
    async getLeaderboard(requestParameters: GetLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TradingCompetitionLeaderboardResponse> {
        const response = await this.getLeaderboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Join a trading competition using invite code
     * Join trading competition
     */
    async joinCompetitionRaw(requestParameters: JoinCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['joinTradingCompetitionRequest'] == null) {
            throw new runtime.RequiredError(
                'joinTradingCompetitionRequest',
                'Required parameter "joinTradingCompetitionRequest" was null or undefined when calling joinCompetition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/trading-competition/join`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['joinTradingCompetitionRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Join a trading competition using invite code
     * Join trading competition
     */
    async joinCompetition(requestParameters: JoinCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.joinCompetitionRaw(requestParameters, initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetCompetitionsStatusEnum {
    Upcoming = 'UPCOMING',
    Ongoing = 'ONGOING',
    Ended = 'ENDED'
}
